module.exports = __webpack_public_path__ + "static/img/up.2294cf0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/doubleDan/up.png
// module id = YzGF
// module chunks = 1